import FocusedViewFilter from 'owa-service/lib/contract/FocusedViewFilter';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import getFocusedFilterForTable from 'mini-mail-list-store/lib/utils/getFocusedFilterForTable';
import getSelectedTableView from 'mini-mail-list-store/lib/utils/getSelectedTableView';
import TableQuery from 'mini-mail-list-store/lib/store/schema/TableQuery';

export const canShowUpNext = (): boolean => {
    const selectedTableView = getSelectedTableView();
    if (!selectedTableView) {
        return false;
    }

    const selectedTableViewQuery = selectedTableView.tableQuery as TableQuery;

    if (selectedTableViewQuery.folderId !== folderNameToId('inbox')) {
        return false;
    }

    if (getFocusedFilterForTable(selectedTableView) === FocusedViewFilter.Other) {
        return false;
    }

    return true;
};
